/**
 * 判断设备
 */
const getOS = () => {
    const userAgent = navigator?.userAgent?.toLowerCase() || '';
    const appVersion = navigator.appVersion.toLowerCase() || '';

    if (
        /iphone/i.test(userAgent) ||
        /ipad/i.test(userAgent) ||
        /ipod/i.test(userAgent)
    )
        return 'ios';
    if (/android/i.test(userAgent)) return 'android';
    if (/win/i.test(appVersion) && /phone/i.test(userAgent))
        return 'windowsPhone';
    if (/mac/i.test(appVersion)) return 'MacOSX';
    if (/win/i.test(appVersion)) return 'windows';
    if (/linux/i.test(appVersion)) return 'linux';
};

export default getOS;
